import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const DECODE_NAV_QUERY = gql`
  {
    globalSets {
      name
      ... on decodeGlobalNavigation_GlobalSet {
        decodeGlobalNavFields {
          ... on decodeGlobalNavFields_BlockType {
            logo {
              url
            }
            logoMobile {
              url
            }
            description
            expandedCopy
            navigationItems {
              id
              title
              slug
              ... on decodeCategories_Category {
                decodeCategoryDescription {
                  ... on decodeCategoryDescription_BlockType {
                    decodeCategoryDefaultCopy
                    decodeCategoryExpandedCopy
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const useGlobalNav = () => {
  // Global nav query
  const { data } = useQuery(DECODE_NAV_QUERY);

  if (data) {
    const { globalSets } = data;
    const getDecodeGlobal = globalSets.filter(
      globalSet => globalSet.name === 'DECODE Global Navigation'
    );

    if (getDecodeGlobal.length) {
      const [navContents] = getDecodeGlobal[0].decodeGlobalNavFields;

      if (navContents) {
        return navContents;
      }
    }
  }

  return null;
};

export default useGlobalNav;
